"use client";

import { Skeleton } from "@/app/ui/atomic/animations";
import { createLazyComponent } from "@/app/ui/molecular/createLazyComponent";

const InvestmentCalculator = createLazyComponent(
  () => import("@/app/ui/molecular/InvestmentCalculator"),
  {
    skeleton: {
      type: "custom",
      render: () => (
        <div className="theme-card-alt rounded-xl p-6 shadow-md">
          <Skeleton variant="text" width="60%" height={28} className="mx-auto mb-4" />
          <div className="space-y-6">
            <div>
              <Skeleton variant="text" width="40%" height={16} className="mb-2" />
              <Skeleton variant="rectangular" height={48} className="rounded-lg mb-3" />
              <Skeleton variant="rectangular" height={8} className="rounded-full" />
            </div>
          </div>
        </div>
      ),
    },
  }
);

export default InvestmentCalculator;
